import type { AutoWithdrawalNetworkCode } from '@shared/api/contracts';
import type { WithdrawalNetwork } from '@shared/config/networks';

const NETWORK_META: Record<
  AutoWithdrawalNetworkCode,
  { chainName: string; usdtLabel: string }
> = {
  TRC20: { chainName: 'Tron', usdtLabel: 'USDT · TRC20 (Tron)' },
  ERC20: { chainName: 'Ethereum', usdtLabel: 'USDT · ERC20 (Ethereum)' },
  BEP20: { chainName: 'BNB Chain', usdtLabel: 'USDT · BEP20 (BNB Chain)' },
  BTC: { chainName: 'Bitcoin', usdtLabel: 'BTC' },
  LTC: { chainName: 'Litecoin', usdtLabel: 'LTC' },
};

export const getUsdtNetworkLabel = (networkCode: AutoWithdrawalNetworkCode): string =>
  NETWORK_META[networkCode]?.usdtLabel ?? networkCode;

export const getNetworkChainName = (networkCode: AutoWithdrawalNetworkCode): string =>
  NETWORK_META[networkCode]?.chainName ?? networkCode;

const MANUAL_CHAIN_NAME: Record<WithdrawalNetwork, string> = {
  'ERC-20': 'Ethereum',
  'BEP-20': 'BNB Smart Chain',
  'TRC-20': 'Tron',
};

export const getManualNetworkChainName = (network: string): string =>
  MANUAL_CHAIN_NAME[network as WithdrawalNetwork] ?? network;
